// material-ui
// import { useState } from "react";
// import { Typography } from "@mui/material";
import AuthContext from "../../../contexts/JWTContext";
// project-imports
import MainCard from "components/MainCard";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HtmlRenderer from "../_Componenet/HtmlRenderer";
import { seek } from "./Component";
// import { Component } from "iconsax-react";
// ==============================|| SAMPLE PAGE ||============================== //

const SamplePage = () => {
  const context = useContext(AuthContext);
  const [data, setData] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    // debugger
    if (!sessionStorage.getItem("aduanainfo")) {
      navigate("/");
    }
  }, [context?.state]);
  useEffect(() => {
    seek()
      .then((res: any) => {
        if (!res.data.Error) {
          setData(res.data.Recordset[0].info);
        }
        else {
          setData(res.data.DescripcionError);
        }
      })
      .catch((err) => {});
  }, [context?.state]);

  // const sanitizedHtml = '<h1>Hola, mundo!</h1><p>Este es un párrafo con <b>negrita</b>.</p>'; // HTML sanitizado
  return (
    <>
      {" "}
      <MainCard title={sessionStorage.getItem('aduanainfo') }>
        {/* <Typography variant="body1">
          Sistema SIM@ {" "}
        </Typography> */}
        <HtmlRenderer htmlContent={data} />
      </MainCard>
    </>
  );
};

export default SamplePage;
